import { styled } from '@mui/material';

export const StyledLessonDescriptionCommentWrap = styled('div')({
	display: 'flex',
	gap: '10px',
	flexDirection: 'column',
	padding: '20px 10px',
});

export const StyledLessonDescriptionCommentList = styled('div')({
	display: 'flex',
	flexDirection: 'column',
	gap: '8px',
});
